namespace TabAurous.ECommerce {
    export interface OrderReceiptRow {
        Id?: number;
        TransId?: number;
        ModeId?: number;
        LedgerId?: number;
        Code?: string;
        Amount?: number;
        RefNo?: string;
        ChequeNo?: number;
        ChequeDate?: string;
        Scheme?: string;
        RefTransId?: number;
        RefVoucherType?: number;
        SchemeEnrollmentId?: number;
        BankId?: number;
        ReceiptDetails?: OrderReceiptRow[];
    }

    export namespace OrderReceiptRow {
        export const idProperty = 'Id';
        export const nameProperty = 'RefNo';
        export const localTextPrefix = 'ECommerce.OrderReceipt';
        export const deletePermission = 'EComm:ECommOrder:Delete';
        export const insertPermission = 'EComm:ECommOrder:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommOrder:Edit';

        export declare const enum Fields {
            Id = "Id",
            TransId = "TransId",
            ModeId = "ModeId",
            LedgerId = "LedgerId",
            Code = "Code",
            Amount = "Amount",
            RefNo = "RefNo",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            Scheme = "Scheme",
            RefTransId = "RefTransId",
            RefVoucherType = "RefVoucherType",
            SchemeEnrollmentId = "SchemeEnrollmentId",
            BankId = "BankId",
            ReceiptDetails = "ReceiptDetails"
        }
    }
}
